module.exports = __webpack_public_path__ + "img/flagUSD.bbe80b32.svg";